<template>
  <PropertyOnboardingStep
    :is-next-button-disabled="formRef?.form.validation.$invalid"
    title="Monthly rent, deposits & fees"
    :submit="submit"
  >
    <LeaseConditionsForm ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { LeaseConditionsForm } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const formRef = ref<InstanceType<typeof LeaseConditionsForm>>();

async function submit() {
  await formRef.value?.save();
}
</script>
